import { motion } from "framer-motion";

export default function ChapterHeading({ num, title, sub, accent = "text-neon-lime" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="mb-12"
    >
      <div className={`font-mono text-xs uppercase tracking-[0.35em] ${accent}`}>{num}</div>
      <h2 className="mt-3 font-editorial text-2xl uppercase tracking-wide sm:text-3xl lg:text-4xl">
        {title}
      </h2>
      <p className="mt-3 max-w-2xl text-sm text-zinc-400 sm:text-base">{sub}</p>
    </motion.div>
  );
}
